import React, { useState } from 'react';
import { Check } from 'lucide-react';
import api from '../api/client';

// Cambio password volontario, riusabile in qualunque portale (staff/allenatore/cliente) —
// a differenza di CambiaPasswordObbligatoria.js non blocca la navigazione, è una pagina normale.
export default function CambiaPassword() {
  const [form, setForm] = useState({ passwordAttuale: '', nuovaPassword: '', conferma: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess(false);
    if (form.nuovaPassword !== form.conferma) { setError('Le due password non coincidono'); return; }
    if (form.nuovaPassword.length < 8) { setError('La nuova password deve essere di almeno 8 caratteri'); return; }
    setLoading(true);
    try {
      await api.post('/auth/cambia-password', { passwordAttuale: form.passwordAttuale, nuovaPassword: form.nuovaPassword });
      setForm({ passwordAttuale: '', nuovaPassword: '', conferma: '' });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Errore');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth: '440px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={s.title}>Cambia password</h1>
        <p style={s.sub}>Aggiorna la password del tuo account in qualunque momento.</p>
      </div>

      <form onSubmit={handleSubmit} style={s.card}>
        <div style={s.field}>
          <label style={s.label}>PASSWORD ATTUALE</label>
          <input style={s.input} type="password" value={form.passwordAttuale} onChange={set('passwordAttuale')} required />
        </div>
        <div style={s.field}>
          <label style={s.label}>NUOVA PASSWORD</label>
          <input style={s.input} type="password" value={form.nuovaPassword} onChange={set('nuovaPassword')} placeholder="Minimo 8 caratteri" required />
        </div>
        <div style={s.field}>
          <label style={s.label}>CONFERMA NUOVA PASSWORD</label>
          <input style={s.input} type="password" value={form.conferma} onChange={set('conferma')} required />
        </div>

        {error && <div style={s.error}>{error}</div>}
        {success && <div style={s.success}><Check size={14}/> Password aggiornata.</div>}

        <button type="submit" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
          {loading ? 'SALVATAGGIO...' : 'AGGIORNA PASSWORD'}
        </button>
      </form>
    </div>
  );
}

const s = {
  title:  { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:    { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginTop:'4px' },
  card:   { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', padding:'24px', display:'flex', flexDirection:'column', gap:'16px' },
  field:  { display:'flex', flexDirection:'column', gap:'7px' },
  label:  { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'10px 12px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  success:{ display:'flex', alignItems:'center', gap:'8px', background:'#22C55E20', border:'1px solid #22C55E40', borderRadius:'8px', padding:'10px 14px', color:'#22C55E', fontSize:'var(--font-size-sm)', fontWeight:'700' },
  btn:    { background:'#F4600C', color:'#fff', border:'none', borderRadius:'8px', padding:'12px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px' },
};
